import { render, staticRenderFns } from "./tarif-acte.html?vue&type=template&id=4aa8bc41&scoped=true&external"
import script from "./tarif-acte.js?vue&type=script&lang=js&external"
export * from "./tarif-acte.js?vue&type=script&lang=js&external"
import style0 from "./tarif-acte.scss?vue&type=style&index=0&id=4aa8bc41&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa8bc41",
  null
  
)

export default component.exports